<template>
	<v-row justify="center">
		<v-col align="center" cols="12" lg="6" md="6" sm="8">
			<v-container>
				<h1 class="title-shadow">Contact Me</h1>
				<v-form>
					<div class="mt-3 text-start">
						<label class="ml-3">
							Your Name
							<transition
								name="errorMessageAnimation"
								type="transition"
								mode="in-out"
								appear
							>
								<span v-if="!name.isMessageValid">
									{{ name.errorMessage }}
								</span>
							</transition>
						</label>
					</div>

					<v-text-field
						v-model="name.input"
						:color="inlineStyles.colors.secondary"
						placeholder="Your Name"
						:append-icon="name.isMessageValid ? '' : 'mdi-alert'"
						@blur="validateInput('name')"
						@input="validateInput('name')"
						hide-details
						clearable
						outlined
						dense
						dark
					/>

					<div class="mt-3 text-start">
						<label class="ml-3">
							Your E-mail
							<transition
								name="errorMessageAnimation"
								type="transition"
								mode="in-out"
								appear
							>
								<span v-if="!email.isMessageValid">
									{{ email.errorMessage }}
								</span>
							</transition>
						</label>
					</div>
					<v-text-field
						v-model="email.input"
						:color="inlineStyles.colors.secondary"
						placeholder="Your E-mail"
						:append-icon="email.isMessageValid ? '' : 'mdi-alert'"
						@blur="validateInput('email')"
						@input="validateInput('email')"
						hide-details
						clearable
						outlined
						dense
						dark
					/>

					<div class="mt-3 text-start">
						<label class="ml-3">
							Subject
							<transition
								name="errorMessageAnimation"
								type="transition"
								mode="in-out"
								appear
							>
								<span v-if="!subject.isMessageValid">
									{{ subject.errorMessage }}
								</span>
							</transition>
						</label>
					</div>

					<v-text-field
						v-model="subject.input"
						:color="inlineStyles.colors.secondary"
						placeholder="Subject"
						:append-icon="subject.isMessageValid ? '' : 'mdi-alert'"
						@blur="validateInput('subject')"
						@input="validateInput('subject')"
						hide-details
						clearable
						outlined
						dense
						dark
					/>

					<div class="mt-3 text-start">
						<label class="ml-3">
							Your Message
							<transition
								name="errorMessageAnimation"
								type="transition"
								mode="in-out"
								appear
							>
								<span v-if="!message.isMessageValid">
									{{ message.errorMessage }}
								</span>
							</transition>
						</label>
					</div>

					<v-textarea
						v-model="message.input"
						:color="inlineStyles.colors.secondary"
						placeholder="Your Message"
						:append-icon="message.isMessageValid ? '' : 'mdi-alert'"
						@blur="validateInput('message')"
						@input="validateInput('message')"
						auto-grow
						clearable
						outlined
						dark
					/>

					<v-btn
						:color="inlineStyles.colors.secondary"
						:loading="isButtonLoading"
						@click="sendMail()"
						outlined
					>
						Send Your Message
					</v-btn>

					<!-- Sending Message Dialog -->
					<v-dialog v-model="isDialogVisible" width="500" persistent>
						<v-card>
							<v-container class="card-center">
								<v-btn
									v-if="isDialogLoading"
									loading
									x-small
									text
								/>

								<v-icon v-else :color="dialogStatus" x-large>
									{{dialogIcon}}
								</v-icon>

								<h2 class="text-center">{{dialogText}}</h2>

								<v-card-actions>
									<v-btn
										v-if="!isDialogLoading"
										@click="isDialogVisible=false"
										color="primary"
										text
									>
										close
									</v-btn>
								</v-card-actions>
							</v-container>
						</v-card>
					</v-dialog>
				</v-form>
			</v-container>
		</v-col>
	</v-row>
</template>

<script>
import axios from "axios"

export default {
	name: "ContactView",
	props: {
		inlineStyles: {
			type: Object,
			require: true,
		},
	},
	// Data Ordered Alphabetically
	data: () => ({
		dialogText: "",
		dialogIcon: "",
		dialogStatus: "",
		inputNames: ["name", "email", "subject", "message"],
		isButtonLoading: false,
		isDialogVisible: false,
		isDialogLoading: false,
		email: { input: "", isMessageValid: true, errorMessage: "" },
		message: { input: "", isMessageValid: true, errorMessage: "" },
		name: { input: "", isMessageValid: true, errorMessage: "" },
		subject: { input: "", isMessageValid: true, errorMessage: "" }
	}),

	computed: {
		isFormValid() {
			if(
				this.name.isMessageValid &&
				this.email.isMessageValid &&
				this.subject.isMessageValid &&
				this.message.isMessageValid
			){
				return true
			}else{
				return false
			}
		}
	},

	methods: {
		sendMail() {
			this.inputNames.forEach(elem => this.validateInput(elem))

			if(this.isFormValid){
				this.isButtonLoading = true
				this.isDialogVisible = true

				this.dialogText = "Sending Your Message..."
				this.dialogIcon = "mdi-loading"
				this.dialogStatus = ""

				axios.post("https://javi-co-default-rtdb.firebaseio.com/messages.json", {
					name: this.name.input,
					email: this.email.input,
					subject: this.subject.input,
					message: this.message.input,
					sendDate: new Date(),
				})
				.then(() => {
					this.isDialogLoading = false
					this.isButtonLoading = false
					
					this.dialogText = "Message sent successfully."
					this.dialogIcon = "mdi-check-bold"
					this.dialogStatus = "success"

					this.name.input = null
					this.email.input = null
					this.subject.input = null
					this.message.input = null
				})
				.catch(() => {
					this.isDialogLoading = false
					this.isButtonLoading = false

					this.dialogIcon = "mdi-close-thick"
					this.dialogStatus = "error"
					this.dialogText = "Error. Something went wrong..."
				})
			}
		},

		validateInput(inputName) {
			const isValidInput = inputName == "email" ? false : true

			const pronoun = inputName == "name" || inputName == "email" ?
				"your" : "a"
			
			const regex = inputName == "email" ?
				/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ : /^\s+$/

			switch(true){
				case (this[inputName].input == "" || this[inputName].input == null):
					this[inputName].errorMessage = ` → Please, write ${pronoun} ${inputName}`
					this[inputName].isMessageValid = false
					break
				case (regex.test(this[inputName].input) == isValidInput):
					this[inputName].errorMessage = ` → Please, write a valid ${inputName}`
					this[inputName].isMessageValid = false
					break
				default:
					this[inputName].isMessageValid = true
			}
		}
	},
};
</script>

<style scoped>
/* HTML Styles */
.card-center {
	display: flex;
  flex-direction: column;
  align-items: center;
}
.title-shadow {
	text-shadow: 2px 2px 4px black
}

/* Transitions Styles */
.errorMessageAnimation-enter-active,
.errorMessageAnimation-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.8, 0.8, 1);
}
.errorMessageAnimation-enter,
.errorMessageAnimation-leave-to {
	transform: translateX(-100px);
	opacity: 0.1;
	margin-bottom: 0px;
}
</style>